/**
 * Dijital davetiye demo içeriği (Elif & Hakan örneği).
 * Görseller: public/invitations/elifhakan/ altındaki demo görselleri.
 * Müzik: public/invitations/thinking_out_loud.mp3
 */
export const elifHakanInvitation = {
    couple: {
        bride: 'Elif',
        groom: 'Hakan',
        initials: 'E&H',
    },
    landing: {
        title: 'Elif & Hakan',
        hint: 'Açmak için mühüre dokunun',
        background: '/invitations/elifhakan/demo-hero.jpg',
    },
    envelope: {
        seal: '/invitations/elifhakan/wax-seal-gold.png',
    },
    main: {
        tagline: 'Özel günler birlikte güzel..',
        message:
            'Bu özel günümüzde sizleri de aramızda görmekten mutluluk duyarız.',
        headline: 'Büyük Gün Geldi!',
        background: '/invitations/elifhakan/demo-hero.jpg',
        story: {
            title: 'Hikayemiz',
            quote:
                'Bazı insanlar hayatınıza girer ve kalbinizin ritmini sonsuza dek değiştirir.',
            milestones: [
                {year: '2020', label: 'İlk Buluşma'},
                {year: '2023', label: 'Nişan'},
                {year: '2026', label: 'Düğün'},
            ],
        },
    },
    gallery: {
        left: [
            {src: '/invitations/elifhakan/demo-photo-1.jpg', alt: 'Düğün detayı'},
            {src: '/invitations/elifhakan/demo-photo-2.jpg', alt: 'Düğün anı'},
            {src: '/invitations/elifhakan/demo-photo-3.jpg', alt: 'Gelin buketi'},
            {src: '/invitations/elifhakan/demo-photo-1.jpg', alt: 'Düğün detayı'},
        ],
        right: [
            {src: '/invitations/elifhakan/demo-photo-2.jpg', alt: 'Düğün anı'},
            {src: '/invitations/elifhakan/demo-photo-3.jpg', alt: 'Gelin buketi'},
            {src: '/invitations/elifhakan/demo-photo-1.jpg', alt: 'Düğün detayı'},
            {src: '/invitations/elifhakan/demo-photo-2.jpg', alt: 'Düğün anı'},
        ],
        mobile: [
            {src: '/invitations/elifhakan/demo-photo-1.jpg', alt: 'Düğün detayı'},
            {src: '/invitations/elifhakan/demo-photo-2.jpg', alt: 'Düğün anı'},
            {src: '/invitations/elifhakan/demo-photo-3.jpg', alt: 'Gelin buketi'},
        ],
    },
    event: {
        dateISO: '2026-09-12T19:00:00',
        date: '12 Eylül 2026 Cumartesi',
        time: '19:00',
        venue: 'Örnek Düğün Salonu',
        address: 'Eskişehir',
        mapUrl: 'https://maps.google.com',
    },
    music: {
        src: '/invitations/thinking_out_loud.mp3',
        title: 'Thinking Out Loud — Ed Sheeran',
    },
};
